import { useState, useEffect } from "react";
import { buscarInfoUsuarioByCotaUsuario } from "../../../services/buscarInfoUsuarioByCotaUsuarioService";

export const useBuscarInfoUser = (
  cotaUsuarioId: number,
  isModalOpen: boolean
) => {
  const [infoUser, setInfoUser] = useState<any>();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetch = async () => {
      if (!isModalOpen || !cotaUsuarioId) {
        setIsLoading(false);
        return;
      }
      setIsLoading(true);
      try {
        const data = await buscarInfoUsuarioByCotaUsuario(cotaUsuarioId);
        setInfoUser(data);
      } catch (error) {
        console.error("Erro ao buscar info do usuario:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetch();
  }, [isModalOpen, cotaUsuarioId]);

  return { infoUser, isLoading };
};
